import { Fragment } from 'react'

import type { CustomFieldSchema } from '@tribeplatform/gql-client/types'
import {
  useListFilters,
  mergeFilters,
  FilterItem,
  type ListFilter,
  type LegacyFilter,
  type RawFilter,
} from '@tribeplatform/react-components/Filters'
import { T } from '@tribeplatform/react-components/i18n'
import { Link } from '@tribeplatform/react-components/Link'
import { GenericSettings } from '@tribeplatform/react-components/Views'
import { SimpleDivider } from '@tribeplatform/react-ui-kit/Divider'

interface Props {
  customFields: CustomFieldSchema[]
  entityFilters: ListFilter[]
  staticFilters: RawFilter[]
  setFilters: (filters: LegacyFilter[]) => void
  goBack: () => void
}

export const FilterSettings = ({
  customFields,
  entityFilters,
  staticFilters,
  setFilters,
  goBack,
}: Props) => {
  const {
    filters: currentFilters,
    allFilters,
    setFilter,
    removeFilter,
  } = useListFilters({
    entityListFilters: entityFilters,
    customFields,
    staticFilters,
    setFilters,
  })
  const filters = mergeFilters(currentFilters, allFilters)

  return (
    <GenericSettings
      title={
        <div className="flex justify-between items-center">
          <T
            defaultMessage="Fixed filters"
            id="ViewSettings.Filters.FixedFiltersLabel"
          />
          {currentFilters.length > 0 && (
            <div className="text-sm font-normal">
              <Link variant="accent" onClick={() => setFilters([])}>
                <T defaultMessage="Clear" id="Generics.Clear.Verb" />
              </Link>
            </div>
          )}
        </div>
      }
      description={
        <T
          defaultMessage="These filters are applied to all the content."
          id="ViewSettings.Filters.FixedFiltersHelperText"
        />
      }
      goBack={goBack}
    >
      {filters.map(filter => (
        <Fragment key={filter.id}>
          <SimpleDivider variant="subdued" />
          <FilterItem
            filter={filter}
            setFilter={setFilter}
            removeFilter={() => removeFilter(filter)}
          />
        </Fragment>
      ))}
    </GenericSettings>
  )
}
